var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f2f55496-ace1-4fba-88e2-5437cbefadf1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-09bb0a07-2e84-42bd-b77f-e3a58c4d486d {\r\n        fill: #2c2c2c;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-09bb0a07-2e84-42bd-b77f-e3a58c4d486d",
    d: "M540,0C241.77,0,0,241.77,0,540s241.77,540,540,540,540-241.76,540-540S838.23,0,540,0ZM725.47,555.74l-261.62,212.26c-3.69,3.01-8.2,4.54-12.76,4.54-2.95,0-5.93-.63-8.7-1.95-7.07-3.38-11.55-10.49-11.55-18.3v-424.56c0-7.8,4.48-14.92,11.55-18.3,7.07-3.27,15.4-2.32,21.46,2.58l261.62,212.31c4.75,3.85,7.49,9.6,7.49,15.71s-2.74,11.87-7.49,15.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/VideoIcon.4c5b9e7c62fcad62111dc9635e490612.svg";
export { ForwardRef as ReactComponent };